import { HttpResponse, delay, http } from 'msw';

import { getCustomHandlerLoginStatus } from './utils';
import { MOCK_DELAY } from './utils/constants';

export const getCustomPlatformGetSyncRunTablesMockHandler = () => {
  return http.get('*/teams/:team/syncs/:sync_name/runs/:run_id/tables', async () => {
    await delay(MOCK_DELAY);

    if (!getCustomHandlerLoginStatus()) {
      return new HttpResponse(null, { status: 401 });
    }

    const items = [
      {
        completed_at: '2024-07-14T17:37:42Z',
        errors: 2,
        name: 'aws_ec2_instances',
        panics: 0,
        resources: 20,
        service_name: 'aws',
        started_at: '2024-07-14T16:53:42Z',
      },
      {
        completed_at: undefined,
        errors: 0,
        name: 'aws_ec1_instances',
        panics: 0,
        resources: 12_383,
        service_name: 'aws',
        started_at: '2024-12-18T15:00:42Z',
      },
      {
        completed_at: '2024-07-14T17:45:12Z',
        errors: 5,
        name: 'aws_s3_buckets',
        panics: 1,
        resources: 156,
        service_name: 'aws',
        started_at: '2024-07-14T17:30:42Z',
      },
      {
        completed_at: '2024-07-14T18:12:33Z',
        errors: 0,
        name: 'aws_iam_users',
        panics: 0,
        resources: 452,
        service_name: 'aws',
        started_at: '2024-07-14T18:01:15Z',
      },
      {
        completed_at: undefined,
        errors: 12,
        name: 'aws_lambda_functions',
        panics: 2,
        resources: 1253,
        service_name: 'aws',
        started_at: '2024-07-14T18:15:22Z',
      },
      {
        completed_at: '2024-07-14T18:22:45Z',
        errors: 1,
        name: 'aws_rds_instances',
        panics: 0,
        resources: 89,
        service_name: 'aws',
        started_at: '2024-07-14T18:10:33Z',
      },
    ];

    return HttpResponse.json(
      {
        items,
        metadata: {
          last_page: 1,
          page_size: 10,
          time_ms: 100,
          total_count: items.length,
        },
      },
      {
        status: 200,
      },
    );
  });
};
